// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
import axios from 'axios';
import { isEmpty } from '../validators';

const config = {
  API: {
    GraphQL: {
      endpoint: process.env.APPSYNC_API,
      region: 'us-east-1',
      defaultAuthMode: 'apiKey',
      apiKey: process.env.APPSYNC_API_KEY,
    },
  },
};

export default config;

export const setAuthorization = token => {
  if (!isEmpty(token?.Authorization)) {
    axios.defaults.headers.common.Authorization = token?.Authorization;
  } else {
    delete axios.defaults.headers.common.Authorization;
  }
};
